import React, { useState, useLayoutEffect } from "react"

import { Transition } from "react-transition-group"
import { createGlobalStyle } from "styled-components"

import Desktop from "./desktop"
import Mobile from "./mobile"

export default () => {
  const [mobile, setMobile] = useState(true)
  const [opened, setOpened] = useState(false)

  const handleToggle = () => {
    setOpened(!opened)
  }

  useLayoutEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 960 + 16 * 6 + 50 * 2) {
        setMobile(false)
        setOpened(false)
      } else {
        setMobile(true)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      {opened && <FreezeBody />}
      <Transition
        timeout={{ enter: 0, exit: 500 }}
        appear
        mountonEnter
        unmountOnExit
        in={mobile === true}
      >
        {state => (
          <Mobile
            opened={opened}
            toggle={handleToggle}
            animationState={state}
          />
        )}
      </Transition>
      <Transition
        timeout={{ enter: 0, exit: 500 }}
        mountOnEnter
        unmountOnExit
        in={mobile === false}
      >
        {state => <Desktop animationState={state} />}
      </Transition>
    </>
  )
}

const FreezeBody = createGlobalStyle`
  body {
    overflow: hidden;
  }
`
